var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "main-logo",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./logo.png"),
      "alt": "Modus versus logo"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b03b931","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/main-logo/main-logo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3b03b931","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/main-logo/main-logo.vue
// module chunks = index